import React, { useRef } from "react";
import Slider from "react-slick";
import styled, { css } from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import media from "../../styles/media";
import materialOne from "../../images/ArchitectMaterialImage.jpg";
import materialTwo from "../../images/DesignMaterialOne.jpg";
import { SectionWrapper, GutterAddresses } from "../common/Section";
import { DotsWrapper } from "./HeroCarousel";
import BlackArrowPrevious from "../../images/BlackArrowPrevious.svg";
import BlackArrowPreviousMobile from "../../images/BlackArrowPreviousMobile.svg";
import BlackArrowNext from "../../images/BlackArrowNext.svg";
import BlackArrowNextMobile from "../../images/BlackArrowNextMobile.svg";

export const ArchitectWrapper = styled(SectionWrapper)`
  background-color: ${(props) => props.theme.white};
  color: black;
  justify-content: center;
  align-items: center;
  min-width: 0;
  width: 100%;
  min-height: 100vh;
`;

export const SliderContainer = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  min-width: 0;
  height: 66vh;
  max-width: 100%;
  max-height: 70vh;
  margin: 0 auto;
  width: 305px;

  ${media.tablet`
    height: 588px;
    width: 440px;
  `}

  .slick-slide {
    min-width: 0;

    img {
      margin: 0 auto;
      height: 100%;
      max-height: 66vh;
      min-width: 0;
      width: 100%;
      max-width: 100vw;
      justify-content: center;
      align-items: center;
      object-fit: cover;

      ${media.tablet`
        max-height: 80vh;
        height: 588px;
      `}
    }
  }

  .slick-list,
  .slider,
  .slick-track {
    height: 85vh;
    min-width: 0;
    max-height: 85vh;

    ${media.tablet`
      max-height: 80vh;
    `}

    @media(min-width: 1700px) {
      max-height: 70vh;
    }

    @media (min-width: 2000px) {
      max-height: 50vh;
    }
  }
`;

export const Slide = styled.div`
  display: flex;
  position: relative;
  max-width: 100%;
  max-height: 100vh;
  width: 100vw;
  height: 100vh;
  min-width: 0;
`;

export const TitleWrapper = styled.div`
  position: relative;
`;

export const CarouselTitle = styled.h1`
  display: flex;
  position: absolute;
  top: 0;
  margin: 0 auto;
  transform: translate(-50%, -50%);
  z-index: 5;
  left: 50%;
  text-align: center;
  color: ${(props) => props.theme.black};
  letter-spacing: 1.6px;
  font-family: "Saol Text Book";
  font-weight: normal;

  ${media.mobileSmall`
    line-height: 39px;
    font-size: 38px;
  `}

  ${media.mobileMedium`
    letter-spacing: 2.6px;
  `}

  ${media.tablet`
    font-size: 45px;
    line-height: 68px;
  `}
`;

export const DotsWrapperMaterial = styled(DotsWrapper)`
  li {
    .dot {
      color: black;
      border: 1px solid black;
      bottom: 115px;
      left: 5px;

      ${media.tablet`
        bottom: -20px;
      `}

      ${media.desktopLarge`
        @media(min-height: 900px){
         bottom: 100px;
        }
      `}
    }

    &.slick-active .dot {
      background-color: black;
    }
  }
`;

export const ArrowPrevious = styled.div`
  position: absolute;
  z-index: 10;
  top: 37.7%;
  right: 90%;

  ${media.tablet`
    top: 42.5%;
    right: 93%;
  `}
`;

export const ArrowNext = styled.div`
  position: absolute;
  z-index: 10;
  top: 37.6%;
  left: 90%;

  ${media.tablet`
    top: 42.5%;
    left: 92.5%;
  `}
`;

export const ImageDesktop = styled.img`
  display: none;

  ${media.tablet`
    display: block;
  `}
`;

export const ImageMobile = styled.img`
  display: block;

  ${media.tablet`
    display: none;
  `}
`;

export const CaptionStyles = css`
  display: flex;
  position: absolute;
  z-index: 5;
  font: normal 11px/13px "Calluna Italic";
`;

export const ImageCaption = styled.figcaption`
  ${CaptionStyles}
  bottom: 21%;
  left: 50%;
  width: 70%;
  transform: translate(-50%, 0);
  text-align: center;

  ${media.tablet`
    display: none;
  `}
`;

export function ArchitectMaterialCarousel() {
  const slideRef = useRef();

  const settings = {
    dots: true,
    draggable: false,
    arrows: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => <DotsWrapperMaterial>{dots}</DotsWrapperMaterial>,
    customPaging: () => <button className='dot' />,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  function PrevArrow() {
    return (
      <ArrowPrevious
        onClick={() => {
          slideRef.current.slickPrev();
        }}
      >
        <ImageDesktop src={BlackArrowPrevious} />
        <ImageMobile src={BlackArrowPreviousMobile} />
      </ArrowPrevious>
    );
  }

  function NextArrow() {
    return (
      <ArrowNext
        onClick={() => {
          slideRef.current.slickNext();
        }}
      >
        <ImageDesktop src={BlackArrowNext} />
        <ImageMobile src={BlackArrowNextMobile} />
      </ArrowNext>
    );
  }

  return (
    <ArchitectWrapper>
      <TitleWrapper>
        <CarouselTitle>Materials</CarouselTitle>
        <SliderContainer>
          <Slider {...settings} ref={slideRef}>
            <Slide>
              <img src={materialOne} alt='building materials' />
              <ImageCaption>
                Tk material used with TK metal on the building&nbsp;façade
              </ImageCaption>
            </Slide>
            <Slide>
              <img src={materialTwo} alt='building materials' />
            </Slide>
            <Slide>
              <img src={materialOne} alt='building materials' />
            </Slide>
            <Slide>
              <img src={materialTwo} alt='building materials' />
            </Slide>
          </Slider>
        </SliderContainer>
      </TitleWrapper>
      <GutterAddresses />
    </ArchitectWrapper>
  );
}
